import React, { useState } from "react";
import _ from "lodash";
import Box from "@mui/material/Box";
import { useOutletContext } from "react-router-dom";
import { useTheme } from "@mui/styles";
import { useIntl } from "react-intl";
import { Tabs } from "@metacrm/metacrm-material-ui/dist/Tabs";
import OnChainCustomizationSection from "./components/OnChainDataCustomizationSection";

const OnChainDataSource = () => {
  const { formatMessage } = useIntl();
  const [entityName] = useOutletContext();
  const theme = useTheme();
  const [ecosystemTabValue, setEcosystemTabValue] = useState(0);

  return (
    <>
      <Box mb="20px" className="fade-up">
        <Box className="title">
          {formatMessage({ id: "dataSourceSetting.header.title" })}
        </Box>
        <Box className="description">
          {formatMessage({ id: "dataSourceSetting.header.description" })}
        </Box>
      </Box>

      <Tabs
        value={ecosystemTabValue}
        onChange={(e, newValue) => setEcosystemTabValue(newValue)}
        tabs={[
          {
            _id: "evm",
            label: formatMessage({
              id: "global.blockchain.evm",
            }),
            content: (
              <Box mt="10px">
                <OnChainCustomizationSection
                  ecosystemName="EVM"
                  entityName={entityName}
                />
              </Box>
            ),
          },
          {
            _id: "solana",
            label: formatMessage({
              id: "global.blockchain.solana",
            }),
            content: (
              <Box mt="10px">
                <OnChainCustomizationSection
                  ecosystemName="Solana"
                  entityName={entityName}
                />
              </Box>
            ),
          },
          {
            _id: "aptos",
            label: formatMessage({
              id: "global.blockchain.aptos",
            }),
            content: (
              <Box mt="10px">
                <OnChainCustomizationSection
                  ecosystemName="Aptos"
                  entityName={entityName}
                />
              </Box>
            ),
          },
        ]}
      ></Tabs>
    </>
  );
};

export default OnChainDataSource;
